import { useTheme } from '@mui/material/styles';
import { useApolloClient } from '@apollo/client';
import { Collapse, Grid, Paper } from '@mui/material';
import React, { useEffect, useRef, useState } from 'react';
import styles from './styles';
import EirValidateCollapseTop from './EirValidateCollapseTop';
import EirValidateCollapseContent from './EirValidateCollapseContent';
import { onGetSelectedOfferTechnology } from './ascertain.util';
import { getPrequalResult } from '../../integration/prequal.api';
import { createAddressObject } from '../eir-broadband/Broadband.util';
import useLocalStorage from '../../hooks/useLocalStorage';
import DuplicateUanErrorModal from './DuplicateUanErrorModal';

/**
 * @name EirValidateBBService - jsx component for validating BB service in  Ascertain Service container
 */
const EirValidateBBService = ({
  bbServiceCheckMark,
  setBBServiceCheckMark,
  setIsPrequalChecking,
  // bbUANValidated,
  getQAForBB,
  errorUANModal,
  hasMultipleUANServices,
  // bbUANError,
  setbbQAResult,
  setBBAccountFound,
  getNLE,
  // NLEData,
  setCartOfferId,
  showLoader,
  setUanDetails,
  setBBUANPhNo,
  uanDetails,
}) => {
  const theme = useTheme();
  const graphql = useApolloClient();
  const localStore = useLocalStorage();
  const [expanded, setExpanded] = useState(true);
  const [bbUanNo, setBbUanNo] = useState();
  const [cartOffer, setCartOffer] = useState();
  const [radioValue, setRadioValue] = useState();
  const [showContent, setShowContent] = useState(false);
  const [nleCheck, setnleCheck] = useState(false);
  const [uanError1, setUANError1] = useState(false);
  const [enableCta, setEnableCta] = useState(false);
  const [duplicateUanModal, setDuplicateUanModal] = useState(false);
  const [qaForBB, setQAForBB] = useState();
  const [selectedUanService, setSelectedUanService] = React.useState();
  const [clickCount, setClickCount] = useState(0);
  const bbUanRef = useRef(null);

  const handleExpandClick = () => {
    setExpanded(!expanded);
  };

  const handleBBuanChange = event => {
    if (event.target.value.match(/^[0-9]{8}$/)) {
      setUANError1(false);
      setEnableCta(true);
    } else if (event.target.value === '') {
      setUANError1(false);
      setEnableCta(false);
    } else {
      setUANError1(true);
      setEnableCta(false);
    }
    setBbUanNo(event.target.value);
  };
  const checkForSlot = async () => {
    const cartoffer = await onGetSelectedOfferTechnology({ graphql });
    const offerData = JSON.parse(localStore.getLocalStorage('PREQUAL_RESULT'))?.services;
    const selectedOffer = offerData?.filter(
      offer => offer?.broadbandTechnology === cartoffer?.broadbandTechnolgy
    );
    setCartOffer(cartoffer);
    setCartOfferId(cartoffer?.offerId);
    // if (selectedOffer[0]?.serviceDate) return false;
    return offerData ? selectedOffer[0]?.slotAvailable : null; // No need to use service Date to find slot available
  };

  const getNLEResponse = async () => {
    setShowContent(false);
    try {
      const { result, errors } = await getNLE();
      if (result?.getNLE) {
        const nleResponse = result?.getNLE;
        if (nleResponse?.status === 'PENDING') {
          setTimeout(() => {
            getNLEResponse();
          }, 300);
        } else if (nleResponse?.status === 'SUCCESS') {
          if (
            nleResponse?.activeFthPathsQuantity > 0 ||
            nleResponse?.spareFthPathsQuantityOntOn > 0
          ) {
            errorUANModal.enable();
          } else {
            setnleCheck(true);
            setBBServiceCheckMark(true);
            setExpanded(false);
            setShowContent(false);
          }
        } else {
          errorUANModal.enable();
        }
      } else {
        errorUANModal.enable();
        console.log(errors);
      }
    } catch (err) {
      console.log('error', err);
      errorUANModal.enable();
    }
  };
  const handleRadioChange = async event => {
    if (event.target.value === 'no') {
      if (await checkForSlot()) {
        await getNLEResponse();
      } else {
        errorUANModal.enable();
      }
    } else {
      setShowContent(true);
    }
    setRadioValue(event.target.value);
  };

  const prequalCheck = async phoneNumber => {
    const phno = phoneNumber.split('-');
    const phone = {
      areaCode: phno[0],
      teleNumber: phno[1].toString(),
    };
    const address = createAddressObject(
      JSON.parse(localStore.getLocalStorage('PREQUAL_RESULT'))?.addressResponse,
      JSON.parse(localStore.getLocalStorage('PREQUAL_RESULT'))?.addressResponse?.eirCode
    );
    const { data, result } = await getPrequalResult(graphql, address, phone);
    console.log(result);
    return !!data;
  };
  const showGenericModals = () => {
    const modal = clickCount > 0 ? errorUANModal.enable() : setDuplicateUanModal(true);
    bbUanRef.current.focus();
    return modal;
  };
  const serviceCheck = async (phoneNumber, qaresult) => {
    // setBBServiceCheckMark(true);
    setIsPrequalChecking(true);
    setSelectedUanService(phoneNumber);
    let activeServices;
    if (qaresult) {
      activeServices = qaresult?.serviceDetails?.filter(
        service => service.phoneNumber === phoneNumber
      )[0].activeServices;
    } else {
      activeServices = qaForBB?.serviceDetails?.filter(
        service => service.phoneNumber === phoneNumber
      )[0].activeServices;
    }
    if (activeServices.filter(service => service === cartOffer?.broadbandTechnolgy).length) {
      setIsPrequalChecking(false);
      errorUANModal.enable();
    }
    if (activeServices.filter(service => service === 'PSTN').length) {
      const qares = {
        accountNumber: qaForBB ? qaForBB?.accountNumber : qaresult?.accountNumber,
        phoneNumber,
      };
      setbbQAResult(qares);
    }
    setBBUANPhNo(phoneNumber);
    // setBBServiceCheckMark(true);
    if (phoneNumber) {
      setIsPrequalChecking(true);
      const prequalResponse = await prequalCheck(phoneNumber);
      if (!prequalResponse) {
        setIsPrequalChecking(false);
        errorUANModal.enable();
      } else {
        setIsPrequalChecking(false);
        setBBServiceCheckMark(true);
        // setExpanded(false);
      }
    }
  };
  const handleCtaClick = async () => {
    setUanDetails({ ...uanDetails, number: bbUanNo });
    if (!checkForSlot()) errorUANModal.enable();
    const { result, errors } = await getQAForBB(bbUanNo);
    if (result) {
      setnleCheck(false);
      if (hasMultipleUANServices) setBBAccountFound(true);
      setQAForBB(result?.getQAForBroadband);
      if (!(result?.getQAForBroadband?.serviceDetails.length > 1)) {
        serviceCheck(
          result?.getQAForBroadband?.serviceDetails[0].phoneNumber,
          result?.getQAForBroadband
        );
      }
      setBBServiceCheckMark(false);
      setExpanded(true);
    } else if (errors === 'Query Account not found') {
      setBBAccountFound(false);
      setBBServiceCheckMark(true);
      // setExpanded(false);
      // setShowContent(false);
    } else {
      // generic error to be added
      showGenericModals();
    }
    setClickCount(clickCount + 1);
  };

  useEffect(() => {
    if (expanded) {
      setRadioValue('yes');
    }
  }, [expanded]);
  useEffect(() => {
    if (radioValue === 'no') {
      setUanDetails({ ...uanDetails, provider: '', number: '' });
      // getNLE();
      // if (NLEData) {
      //   setBBServiceCheckMark(true);
      // }
      // setBBServiceCheckMark(true);
    }
    if (radioValue === 'yes') {
      setBBServiceCheckMark(false);
    }
  }, [radioValue]);
  useEffect(() => {
    if (bbServiceCheckMark && !nleCheck) handleExpandClick();
  }, [bbServiceCheckMark]);

  return (
    <Grid sx={styles(theme).validateBBService}>
      <Paper sx={styles(theme).validateService}>
        <EirValidateCollapseTop
          // checkMark={bbServiceCheckMark || bbUANValidated}
          checkMark={bbServiceCheckMark}
          expanded={expanded}
          handleExpandClick={handleExpandClick}
          numbering='1.'
          text='Do you have active broadband service with another provider?'
          required='*'
          disableCollapse={false}
        />
        <Collapse in={expanded} timeout='auto'>
          <EirValidateCollapseContent
            radioValue={radioValue}
            handleRadioChange={handleRadioChange}
            bbUanRef={bbUanRef}
            handleBBuanChange={handleBBuanChange}
            handleCtaClick={handleCtaClick}
            serviceCheck={serviceCheck}
            qaForBB={qaForBB}
            selectedUanService={selectedUanService}
            showContent={showContent}
            bbUanNo={bbUanNo}
            uanError1={uanError1}
            getQAForBB={getQAForBB}
            enableCta={enableCta}
            errorUANModal={errorUANModal}
            showLoader={showLoader}
            setUanDetails={setUanDetails}
            uanDetails={uanDetails}
          />
        </Collapse>
      </Paper>
      {duplicateUanModal && (
        <DuplicateUanErrorModal
          duplicateUanModal={duplicateUanModal}
          setDuplicateUanModal={setDuplicateUanModal}
        />
      )}
    </Grid>
  );
};

export default EirValidateBBService;
